import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import HeroSection from './Herosection/HeroSection';
import ServicesSection from './homeservices/homeservicespage';
import HeroSpeciality from './homespeciality/Homespeciality';
import CareerReport from './carrerReport/carrerReport';
import HoroscopeSection from './HomeHoroscope/homehoroscope';
import StatsSection from './homecount/homecount';
import AppointmentForm from './homeappointment/homeappointment';
import MembershipHero from './joinushomepage/joinushomepage';
import TestimonialSlider from './hometestimonials/hometestimonials';
import Faqs from './Faqs/Faqs';
import AstrologyConsultCard from './bookingcards/bookincards';
import ConsultationCard from './bookingcards/bookincards';
import AstroConsultCard from './bookingcards/bookincards';

export default function Homepage() {

  // AOS Animation Init
  useEffect(() => {
    AOS.init({ duration: 4000, once: true });
  }, []);

  // Auto Scroll on Page Load
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({
        top: 400,       // scroll distance (change as needed)
        behavior: "smooth",
      });
    }, 800); // wait for page render + AOS animations

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      <section id="home" data-aos="fade-up">
        <HeroSection />
      </section>

      <section id="services">
        <ServicesSection />
      </section>

      <section id="speciality" data-aos="fade-up">
        <HeroSpeciality />
      </section>

      <section id="career" data-aos="fade-up">
        <CareerReport />
      </section>

      <section id="horoscope" data-aos="fade-up">
        <HoroscopeSection />
      </section>

      <section id="stats" data-aos="fade-up">
        <StatsSection />
      </section>

      {/* <section id="ConsultationCard" data-aos="fade-left">
        <AstroConsultCard />
      </section> */}

      <section id="appointment" data-aos="fade-up">
        <AppointmentForm />
      </section>

      <section id="membership" data-aos="fade-up">
        <MembershipHero />
      </section>

      <section id="testimonials" data-aos="fade-up">
        <TestimonialSlider autoPlayMs={2500} />
      </section>

      <section id="Faqs" data-aos="fade-up">
        <Faqs autoPlayMs={2500} />
      </section>
    </div>
  );
}
